import React from 'react'
import { Image } from 'semantic-ui-react'

const LogoPhygitall = () => (
  <Image src="/images/phygitall.svg" size="mini" centered onClick={() => window.location.reload()} />
)

export default LogoPhygitall
